import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './DEBT_Distribution_Calculation_S.css';

const DEBT_Distribution_Calculation_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Debt Note Token Distribution Calculation');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_DISTRIBUTION_CALCULATION/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/DEBT_Distribution_Calculation', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_${i}_SECTION`;
	  const headerId = `#DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_DISTRIBUTION_CALCULATION/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/DEBT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Distribution_Calculation',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [DEBT_DISTRIBUTION_CALCULATION, setDEBT_DISTRIBUTION_CALCULATION] = React.useState(null);
  const [DEBT_DISTRIBUTION_CALCULATION_S, setDEBT_DISTRIBUTION_CALCULATION_S] = React.useState(null);

  var Ids = [];
  for(var Ele in DEBT_DISTRIBUTION_CALCULATION_S){
	  for(var Sec in DEBT_DISTRIBUTION_CALCULATION_S[Ele]){
			if(Sec == "id")
				Ids.push(DEBT_DISTRIBUTION_CALCULATION_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(DEBT_DISTRIBUTION_CALCULATION_S[Ele]["status"]);
			else if(Array.isArray(DEBT_DISTRIBUTION_CALCULATION_S[Ele][Sec]))
				  for(var Row in DEBT_DISTRIBUTION_CALCULATION_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in DEBT_DISTRIBUTION_CALCULATION_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_DISTRIBUTION_CALCULATION`).then((response) => {
      setDEBT_DISTRIBUTION_CALCULATION(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setDEBT_DISTRIBUTION_CALCULATION_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!DEBT_DISTRIBUTION_CALCULATION_S) return <div>Loading...</div>;

 const handleLastDataDEBT_DISTRIBUTION_CALCULATION_S = async (data) => {
  };




  const handleAddDEBT_DISTRIBUTION_CALCULATION_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_DISTRIBUTION_CALCULATION_S', JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_DISTRIBUTION_CALCULATION_S');
      setDEBT_DISTRIBUTION_CALCULATION_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["1"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_0"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("1","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_0",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["1"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_1"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("1","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_1",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["1"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_2"]=value;
	Form_Data_onChange("1","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_2",value,Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
  }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["1"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_3"]=value;
	Form_Data_onChange("1","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_3",value,Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
  }; 
  

const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION));
	Temp_Data["1"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_4"]=value;
	Form_Data_onChange("1","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_4",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddDEBT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION']);
  }; 
  


const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION));
	Temp_Data["2"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_0"]=value;
	Form_Data_onChange("2","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_0",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddDEBT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION']);
  }; 
  

    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["2"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_1"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("2","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_1",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["2"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_2"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("2","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_2",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["2"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_3"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("2","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_3",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["2"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_4"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("2","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_4",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["2"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_5"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("2","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_5",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  

const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION));
	Temp_Data["3"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_0"]=value;
	Form_Data_onChange("3","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_0",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddDEBT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION']);
  }; 
  

    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["3"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_1"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("3","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_1",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["3"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_2"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("3","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_2",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  

const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION));
	Temp_Data["3"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_3"]=value;
	Form_Data_onChange("3","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_3",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddDEBT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION']);
  }; 
  


const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION));
	Temp_Data["4"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_4_0"]=value;
	Form_Data_onChange("4","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_4_0",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddDEBT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION']);
  }; 
  

    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["5"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_5_0"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("5","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_5_0",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["6"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_0"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("6","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_0",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["6"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_1"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("6","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_1",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["6"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_2"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("6","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_2",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["6"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_3"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("6","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_3",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  

const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION));
	Temp_Data["6"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_4"]=value;
	Form_Data_onChange("6","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_4",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddDEBT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION']);
  }; 
  

    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["6"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_5"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("6","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_5",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  

const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION));
	Temp_Data["9"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_0"]=value;
	Form_Data_onChange("9","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_0",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddDEBT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION']);
  }; 
  

    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["9"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_1"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("9","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_1",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["9"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_2"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("9","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_2",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["9"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_3"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("9","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_3",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_DISTRIBUTION_CALCULATION_S));
	Temp_Data["9"]["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_4"]=value;
	//handleAddDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data,App_Data['DEBT_DISTRIBUTION_CALCULATION_S']);
	Form_Data_onChange("9","DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_4",value,Temp_Data);
 	//handleLastDataDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
    setDEBT_DISTRIBUTION_CALCULATION_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = DEBT_DISTRIBUTION_CALCULATION_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Debt Note Token Distribution Calculation')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`DEBT Distribution ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_0" type="text" className="form-control" placeholder="DEBT Distribution ID"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter DEBT Distribution ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_1" type="text" className="form-control" placeholder="Offering ID"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Distribution Period Start`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_2" type="date"   
							onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_2_Change} style={{ borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_2"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Distribution Period Start
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Distribution Period End`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_3" type="date"   
							onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_3_Change} style={{ borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_3"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Distribution Period End
					  </div>
				  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Distribution Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_4"   onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_4_Change} className="form-control" name="Distribution Source"  >
						  <option value="Net Rental Income / NOI">Net Rental Income / NOI</option>
						  <option value="Gross Revenue / Net Operating Revenue">Gross Revenue / Net Operating Revenue</option>
						  <option value="Asset Sale Proceeds">Asset Sale Proceeds</option>
						  <option value="NAV Appreciation / Exit Value">NAV Appreciation / Exit Value</option>
						  <option value="Preferred Return / Profit Waterfall">Preferred Return / Profit Waterfall</option>
						  <option value="Pro Rata Income and Exit Proceeds">Pro Rata Income and Exit Proceeds</option>
						  <option value="Interest and Principal Payments">Interest and Principal Payments</option>
						  <option value="Multiple Sources">Multiple Sources</option>
						  <option value="Conditional Auction Pool / Escrow Refund">Conditional Auction Pool / Escrow Refund</option>
						  <option value="Post-Auction Asset Proceeds">Post-Auction Asset Proceeds</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Distribution Source
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Distribution Component Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_0"   onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_0_Change} className="form-control" name="Distribution Component Type"  >
						  <option value="Gross Source Amount">Gross Source Amount</option>
						  <option value="Operating Expense">Operating Expense</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Debt Service">Debt Service</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Net Distribution">Net Distribution</option>
						  <option value="Investor Distribution">Investor Distribution</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Distribution Component Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Gross Source Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_1" type="text" className="form-control" placeholder="Gross Source Amount USD"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Gross Source Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Operating Expenses USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_2" type="text" className="form-control" placeholder="Operating Expenses USD"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Operating Expenses USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reserve Contribution USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_3" type="text" className="form-control" placeholder="Reserve Contribution USD"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Reserve Contribution USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Debt Service USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_4" type="text" className="form-control" placeholder="Debt Service USD"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_4_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Debt Service USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Preferred Return USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_5" type="text" className="form-control" placeholder="Preferred Return USD"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_5_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Preferred Return USD`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Distribution Component Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_0"   onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_0_Change} className="form-control" name="Distribution Component Type"  >
						  <option value="Gross Source Amount">Gross Source Amount</option>
						  <option value="Operating Expense">Operating Expense</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Debt Service">Debt Service</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Net Distribution">Net Distribution</option>
						  <option value="Investor Distribution">Investor Distribution</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Distribution Component Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Net Distributable Income USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_1" type="text" className="form-control" placeholder="Net Distributable Income USD"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Net Distributable Income USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Distribution Per Token USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_2" type="text" className="form-control" placeholder="Distribution Per Token USD"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Distribution Per Token USD`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Distribution Frequency`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_3"   onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_3_Change} className="form-control" name="Distribution Frequency"  >
						  <option value="Monthly">Monthly</option>
						  <option value="Quarterly">Quarterly</option>
						  <option value="Semiannual">Semiannual</option>
						  <option value="Annual">Annual</option>
						  <option value="At Exit">At Exit</option>
						  <option value="Event Driven">Event Driven</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Distribution Frequency
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Payment Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_4_0"   onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_4_0_Change} className="form-control" name="Payment Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Received">Received</option>
						  <option value="Cleared">Cleared</option>
						  <option value="Failed">Failed</option>
						  <option value="Refunded">Refunded</option>
						  <option value="Cancelled">Cancelled</option>
						  <option value="Paid">Paid</option>
						  <option value="Partially Paid">Partially Paid</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Payment Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Calculation Report Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_5_0" type="text" className="form-control" placeholder="Calculation Report Link"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Calculation Report Link`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_0" type="text" className="form-control" placeholder="Submitted By"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_1" type="text" className="form-control" placeholder="Submitted At"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_2" type="text" className="form-control" placeholder="Reviewed By"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_3" type="text" className="form-control" placeholder="Reviewed At"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_3_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_4"   onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_5" type="text" className="form-control" placeholder="Approval Notes"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_5_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_0"   onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`DEBT Distribution ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Distribution Period Start`)}</th>
                        <th>{t(`Distribution Period End`)}</th>
                        <th>{t(`Distribution Source`)}</th>
                        <th>{t(`Distribution Component Type`)}</th>
                        <th>{t(`Gross Source Amount USD`)}</th>
                        <th>{t(`Operating Expenses USD`)}</th>
                        <th>{t(`Reserve Contribution USD`)}</th>
                        <th>{t(`Debt Service USD`)}</th>
                        <th>{t(`Preferred Return USD`)}</th>
                        <th>{t(`Distribution Component Type`)}</th>
                        <th>{t(`Net Distributable Income USD`)}</th>
                        <th>{t(`Distribution Per Token USD`)}</th>
                        <th>{t(`Distribution Frequency`)}</th>
                        <th>{t(`Payment Status`)}</th>
                        <th>{t(`Calculation Report Link`)}</th>
                        <th>{t(`Submitted By`)}</th>
                        <th>{t(`Submitted At`)}</th>
                        <th>{t(`Reviewed By`)}</th>
                        <th>{t(`Reviewed At`)}</th>
                        <th>{t(`Approval Status`)}</th>
                        <th>{t(`Approval Notes`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {DEBT_DISTRIBUTION_CALCULATION_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_0"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_1"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_2"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_3"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_1_4"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_0"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_1"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_2"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_3"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_4"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_2_5"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_0"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_1"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_2"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_3_3"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_4_0"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_5_0"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_0"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_1"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_2"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_3"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_4"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_6_5"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_0"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_1"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_2"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_3"]} </td>
						<td>{e["DEBT_NOTE_04_DEBT_SERVICING_INTEREST_PAYMENT_MANAGEMENT_DEBT_DISTRIBUTION_CALCULATION_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default DEBT_Distribution_Calculation_S;  